up.Layer.OverlayWithViewport = class OverlayWithViewport extends up.Layer.Overlay {
    static getParentElement() {
        return document.body;
    }
    createElements() {
        up.viewport.bodyShifter.raiseStack();
        this.createElement(this.constructor.getParentElement());
        if (this.backdrop) {
            this.createBackdropElement(this.element);
        }
        this.createViewportElement(this.element);
        this.createBoxElement(this.viewportElement);
        this.createContentElement(this.boxElement);
    }
    onElementsRemoved() {
        up.viewport.bodyShifter.lowerStack();
    }
    sync() {
        if (this.isAlive() && !this.element.isConnected) {
            this.constructor.getParentElement().appendChild(this.element);
        }
    }
};
